import gql from 'graphql-tag';

export const UNAUTH_VERIFY_TOKEN = gql`
query verifyToken($token: String!) {
  verifyToken(token: $token) {
    id
    createdBy {
      id
      firstName
      lastName
    }
    user {
      id
      firstName
      lastName
    }
    survey {
      id
      name
      description
      termsConditions
      shuffle
      public
      activeFrom
      activeTo
      reportQuery
      multisourceResponse
      groupSet {
        edges {
          cursor
          node {
            id
            name
            label
            matrix
            showInResult
            showAvgInResult
            helpText
            sequence
            questionSet {
              edges {
                cursor
                node {
                  id
                  questionText
                  questionAddress
                  required
                  helpText
                  sequence
                  url
                  mediaType
                  choiceSet {
                    edgeCount
                    pageInfo {
                      endCursor
                      hasNextPage
                      hasPreviousPage
                      startCursor
                    }
                    totalCount
                    edges {
                      cursor
                      node {
                        id
                        inputType
                        label
                        sequence
                        value
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    invited
    dateCreated
    message
    valid
    responseSourceFor {
      user {
        firstName
        lastName
      }
    }
  }
}
`;
